import { Inject, Injectable, Injector } from '@angular/core';
import { NgForm } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { FirebaseError } from 'firebase/app';
import { ToastFacade, UiPromiseService } from 'ngx-zcs-components';
import { AuthenticationService } from 'ngx-core-services';

import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ForgotPasswordService {

  private get uiPromiseService() {
    return this.injector.get(UiPromiseService);
  }

  private get authenticationService() {
    return this.injector.get(AuthenticationService);
  }

  private get toastFacade() {
    return this.injector.get(ToastFacade);
  }

  constructor(
    @Inject(Injector) private readonly injector: Injector,
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    readonly translateService: TranslateService,
  ) { }

  async onSubmit(forgotPassword: NgForm): Promise<void> {
    if (forgotPassword.invalid) {
      return;
    }
    forgotPassword.form.markAsPending();
    const { email } = forgotPassword.control.value;

    const { error: authError } = await this.uiPromiseService.run(
      () => this.authenticationService.forgotPassword(email),
      {
        loading: true,
        errorHandler: async (error) => {
          const errorMessage =  this.authenticationService.errorHandler(error as FirebaseError);
          await this.toastFacade.present(
            errorMessage,
            this.translateService.instant('i18n.ForgotPasswordService.errorMessage'),
            {
              severity: 'error',
              browserMode: 'persistent',
            },
          );
          forgotPassword.reset();
        },
      },
    );
    if (authError) {
      return;
    }

    forgotPassword.control.reset();
    await this.toastFacade.present(
      this.translateService.instant('i18n.ForgotPasswordService.checkYourMail'),
      undefined,
      {
        type: 'browser',
        severity: 'error',
        browserMode: 'persistent',
      },
    );
    await this.router.navigate(['../login'], { relativeTo: this.route });
  }
}
